import { render, staticRenderFns } from "./OpportunityMapDataStudio.vue?vue&type=template&id=350ef04e"
import script from "./OpportunityMapDataStudio.vue?vue&type=script&lang=js"
export * from "./OpportunityMapDataStudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports